import { render, staticRenderFns } from "./BrandVehicleList.vue?vue&type=template&id=13e568ed"
import script from "./BrandVehicleList.vue?vue&type=script&lang=js"
export * from "./BrandVehicleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports